import * as React from 'react'
import {LazyLoadComponentWrapper} from '@components/lazy-load/lazy-load-component-wrapper'
import {PageLoadingIndicator} from '@components/page-loading-indicator-mobility-services'
import {QueryClientProvider} from '@tanstack/react-query'
import {reactQueryClient} from '@applications/utility-methods'

const {lazy} = React
const MpexDynamic5gCustomerPage = lazy(
  () => import(/* webpackChunkName:"mpex-dynamic-5g" */ './index'),
)

export const MpexDynamic5gCustomer = () => {
  return (
    <QueryClientProvider client={reactQueryClient}>
      <LazyLoadComponentWrapper
        fallback={<PageLoadingIndicator error={false} />}
        errorIndicator={<PageLoadingIndicator error={true} />}
      >
        <MpexDynamic5gCustomerPage />
      </LazyLoadComponentWrapper>
    </QueryClientProvider>
  )
}
